// JavaScript Document
// Version: 2.0.0

jQuery(document).ready(function($) {
	displayLoading(true, 'init');

	if ( is_defined(Cookies.get('dealer')) ) {
		displayLoading(true, 'initConfigurator');
		Cookies.remove('instance');

		initConfigurator(function() {
			updateConfigurationRecap();
			checkRestoreConfiguration();
		});
	} else {
		checkConnect(
            function(loggedIn, token) {
				displayLoading(true, 'initConfigurator');

				initConfigurator(function() {
					updateConfigurationRecap();
					updateUI(loggedIn);
					checkRestoreConfiguration();
				});
			},
            function(error) {
				displayLoading(false, null);
				showErrorMessage(error, $('#response-modal'));
				console.log(error);
            });
	}



	/**
	 * Applica al body una classe CSS per identificare lo step di configurazione corrente.
	 *
	 * @since 1.1.0
	 */
	if ( $('#pills-steps-tab').length > 0 ) {
		var steps = $('#pills-steps-tab .nav-link');

		steps.each(function(index, element) {
			var stepId = $(element).attr('href').replace('#', '');

			if ( $(element).hasClass('active') ) {
				$('body').addClass(stepId);
			} else {
				$('body').removeClass(stepId);
			}
		});
	}

	$('#pills-steps-tab .nav-link').on('click', function() {
		var selectedStepId = $(this).attr('href').replace('#', '');
		var otherStepIds   = $.map($('#pills-steps-tab .nav-link[href!="#' + selectedStepId + '"]'), function(element, index) {
			return $(element).attr('href').replace('#', '');
		});

		$('body').addClass(selectedStepId).removeClass(otherStepIds.join(' '));
	});



});





/**
 * Inizializza il configuratore.
 *
 * @since 1.1.0
 */
function initConfigurator(callback) {
	var primaryComponentCtx     = getPrimaryComponentCtx();
	var primarySurfaceCtx       = getActiveSurfaceCtx(primaryComponentCtx);
	var primarySurfaceCode      = primarySurfaceCtx.data('surface-code');
	var primaryColorCtx         = getActiveColorCtx(primarySurfaceCtx)
	var primaryColorCode        = primaryColorCtx.data('asset-color-code');
	var primaryAlternativeColor = primaryColorCtx.data('alternative-color');

	showColorLegend(primaryComponentCtx);
	updateComponentsSurfaces(primarySurfaceCode, primaryColorCode, primaryAlternativeColor);
	ET1(true, primaryColorCtx);
	ET2(true, primaryColorCtx);
	removeOptionHandler();
	reorderComponentsOptions();
	updatePrintAreas();
	updateTextColorPalette();
	updateQRCodes(); // @since 2.0.0
	updateWritingSystemOptions();
	refreshPreview();

	if ( is_defined(callback) && jQuery.isFunction(callback) ) {
		callback();
	}
}



/**
 * Aggiorna le immagini di anteprima della penna.
 *
 * @since 1.0.0
 */
function refreshPreview() {
	var elements = jQuery('.pen-preview img.pen-picture');

	jQuery(elements).each(function(index, element) {
		var that         = jQuery(element);
		var componentId  = that.data('component-id');
		var componentCtx = getComponentCtxByDataAttribute([
			{
				dataAttribute: 'component-id',
				attributeValue: componentId,
				dataRelation: '='
			}
		]);
		var surfaceCtx   = getActiveSurfaceCtx(componentCtx);
		var colorCtx     = getActiveColorCtx(surfaceCtx);

		newColorCode     = getAssetColorCode(colorCtx);//colorCtx.data('asset-color-code');

		var newFilename  = that.attr('src').substring(0, that.attr('src').lastIndexOf('/') + 1);
        var filename     = that.attr('src').substr(that.attr('src').lastIndexOf('/') + 1).split('.')[0];
		var codes        = filename.split('_');

		// I nomi dei file delle anteprime delle penne hanno la seguente struttura "{slug del componente}_{codice del colore}_{codide della vista}.png".
		newFilename     += codes[0] + '_' + newColorCode + '_' + codes[2] + '.png';

		that.attr('src', newFilename);
	});

	var elements = jQuery('.pen-preview img.refill-picture');

	if (elements.length > 0) {
		var refillOptionsCtx      = getRefillOptionsCtx();
		var selectedRefillCtx     = getSelectedRefillCtx(refillOptionsCtx);
		var refillId              = selectedRefillCtx.data('refill-id');
		var refillExtraOptionsCtx = getRefillExtraOptionsCtx(refillOptionsCtx, refillId);
		var refillColorsCtx       = getRefillColorOptionsCtx(refillExtraOptionsCtx, refillId);
		var selectedColorCtx      = getActiveRefillColorCtx(refillColorsCtx);
		var refillColorCode       = selectedColorCtx.data('color-code');

		elements.each(function(index, element) {
			var imageCtx = jQuery(element);

			if ( imageCtx.data('refill-id') != refillId ) {
				imageCtx.hide().addClass('hidden');
			} else {
				var newFilename = imageCtx.attr('src').substring(0, imageCtx.attr('src').lastIndexOf('/') + 1);
				var filename    = imageCtx.attr('src').substr(imageCtx.attr('src').lastIndexOf('/') + 1).split('.')[0];
				var codes       = filename.split('_');

				// I nomi dei file delle anteprime dei refill hanno la seguente struttura "{slug del refill}_{codice del colore}_{codide della vista}.png".
				newFilename    += codes[0] + '_' + refillColorCode + '_' + codes[2] + '.png';

				imageCtx.attr('src', newFilename).show().removeClass('hidden');
			}
		});
	}
}



/**
 * Verifica se è stata richiesta una particolare configurazione.
 *
 * @since 1.1.0
 */
function checkRestoreConfiguration() {
	// Origine richiesta: pagina prodotti del sito prodir.com.
	if ( urlParam('surface') != null && urlParam('color') != null ) {
		var surface      = urlParam('surface');
		var color        = urlParam('color');
		var reg          = /^\d+$/;
		var args         = {
			surface: surface,
			color: ( reg.test(color) ) ? surface + color : color,
			option: urlParam('option')
		};
		var extendedArgs = {
			altColor: urlParam('altcolor'),
			subset: urlParam('subset'),
			msg: urlParam('msg')
		};

		displayLoading(true, 'load');

		restoreProductConfiguration(args, extendedArgs);
	}


	// Origine richiesta: homepage del configuratore.
	if ( urlParam('configuration') != null ) {
		var configuration = urlParam('configuration');
		var restricted    = (urlParam('restricted') != null) ? urlParam('restricted') : '';

		displayLoading(true, 'load');

		restoreHomeConfiguration(configuration, restricted);
	}


	// Origine richiesta: pagina "My pens" del sito prodir.com.
	if ( is_defined(Cookies.get('nodeId')) ) {
		displayLoading(true, 'load');

		var nodeId = Cookies.get('nodeId');

		jQuery.ajax({
			url: minerva_drupal_vars.host + '/' + Cookies.get('wp-wpml_current_language') + minerva_drupal_vars.endpoints.load.replace('{nodeId}', nodeId),
			type: "GET",
			headers: {
				"Content-Type": "application/json",
				"Accept": "application/json",
			},
			success: function (result) {
				var xmlConfiguration          = (result.hasOwnProperty('field_xmlconfiguration')) ? result.field_xmlconfiguration[0].value : '';
				var xmlExtendedConfiguration  = (result.hasOwnProperty('field_xmlextendedconfiguration')) ? result.field_xmlextendedconfiguration[0].value : '';

				// "result" è un JSON così srutturato:
				//    {
				//       field_jsonconfiguration: [{ value: JSON sottoforma di stringa }]
				//       field_jsonextendedconfiguration: [{ value: JSON sottoforma di stringa }]
				//       field_model: [{ value: "" }]
				//       field_penid: [{ value: "" }]
				//       ...
				//    }
				var jsonConfiguration         = (result.hasOwnProperty('field_jsonconfiguration')) ? result.field_jsonconfiguration[0].value : '';
				var jsonExtendedConfiguration = (result.hasOwnProperty('field_jsonextendedconfiguration')) ? result.field_jsonextendedconfiguration[0].value : '';

				/*
				 * 2021.08.25
				 * Molto probabilmente durante l'import delle vecchie configurazioni da Drupal 7 a Drupal 8 è stato generato il seguente errore all'interno del JSON:
				 *    {
				 *       ""productCode"":""DS7 PPP-M"",
				 *       ""penModelName"":""DS7"",
				 *       ""penModelId"":425,
				 *       ""components"":
				 *          [
				 *             {
				 *                ""componentLabel"":""Pen"",
				 *                ""componentId"":729,
				 *                ""finishingCode"":""P"",
				 *                ""finishingId"":597,
				 *                ""colorCode"":""P02""
				 *             },
				 *             ...
			 	 *          ],
				 *       ""writingSystem"":
				 *          {
				 *             ""refillLabel"":""Floating Ball® (plastic) Lead free"",
				 *             ""refillId"":198,
				 *             ""optionId"":1,
				 *             ""colorName"":""Blue"",
				 *             ""ballDiameter"":""1.0 mm"",
				 *             ""refillColorCode"":""""
			 	 *          },
				 *       ""moq"":500
			 	 *    }
				 */
				/* START */
				if ( jsonConfiguration.indexOf('{""') > -1 ) {
					jsonConfiguration = jsonConfiguration.replace(/""""/g, 'null');
					jsonConfiguration = jsonConfiguration.replace(/""/g, '"');
				}

				if ( jsonExtendedConfiguration.indexOf('{""') > -1 ) {
					jsonExtendedConfiguration = jsonExtendedConfiguration.replace(/""""/g, 'null');
					jsonExtendedConfiguration = jsonExtendedConfiguration.replace(/""/g, '"');
				}
				/* END */

				if ( jsonConfiguration != '' && jsonExtendedConfiguration != '' ) {
					restoreJSONConfiguration(jsonConfiguration, jsonExtendedConfiguration);
				} else if ( '' != xmlConfiguration ) {
					xmlConfiguration         = $($.parseXML(xmlConfiguration));
					xmlExtendedConfiguration = $($.parseXML(xmlExtendedConfiguration));

					restoreXMLConfiguration(xmlConfiguration, xmlExtendedConfiguration, productId);
				}

				Cookies.remove('productId');
				Cookies.remove('nodeId');
			},
			error: function(error) {
				console.log(error);

				displayLoading(false, null);
				showErrorMessage(error, jQuery('#response-modal'));
				Cookies.remove('productId');
				Cookies.remove('nodeId');
			}
		});
	}

	displayLoading(false, null);
}



/**
 * Effettua il restore di una configurazione a partire da un XML.
 *
 * @param {string} xmlConfiguration         : oggetto XML con i dati della penna
 * @param {string} xmlExtendedConfiguration : oggetto XML con i dati delle aree di stampa
 * @param {string} productId                : ID del modello di penna
 *
 * @since 1.0.0
 */
function restoreXMLConfiguration(xmlConfiguration, xmlExtendedConfiguration, productId) {
	var xml          = jQuery.parseXML(xmlConfiguration);
	var xmlDoc       = jQuery(xml);
	var pickers      = ['propertyPicker2_2', 'propertyPicker2_1', 'propertyPicker3', 'optionPicker', 'optionPicker2'];
	var materialId;
	var colorId;
	var componentId;
	var surfaces;
	var surfaceId;
	var paletteId;
	var colors;
	var colorCode;
	var components   = new Array();
	var componentItem;
	var languageCode = Cookies.get('wp-wpml_current_language');
	var missing      = [];

	jQuery.each(pickers, function(index, value) {
		materialId  = parseInt(xmlDoc.find('configuration ' + value + ' materialId').text());
		colorId     = parseInt(xmlDoc.find('configuration ' + value + ' colorId').text());
		componentId = mapping[productId.toString()][value]['componentId'][languageCode];

		if ( componentId != '' ) {
			surfaces = mapping[productId.toString()][value]['surfaces'];

			jQuery.each(surfaces, function(i, v) {
				if ( surfaces[i]['materialId'] == materialId ) {
					surfaceId = surfaces[i]['surfaceId'][languageCode];
					paletteId   = surfaces[i]['paletteId'][languageCode];
					colors      = surfaces[i]['colors'];
					colorCode   = colors[colorId];

					componentItem = {
						componentId: componentId,
						surfaceId: surfaceId,
						colorCode: colorCode
					};

					components.push(componentItem);
				}
			});
		}
	});

	jQuery.each(components, function(index, value) {
		var componentCtx = getComponentCtxByDataAttribute([
			{
				dataAttribute: 'component-id',
				attributeValue: value.componentId,
				dataRelation: '='
			}
		]);
		var surfaceCtx   = getSurfaceCtxByDataAttribute([
			{
				dataAttribute: 'surface-id',
				attributeValue: value.surfaceId,
				dataRelation: '='
			}
		], false, componentCtx);
		var colorCtx     = getColorCtxByDataAttribute([
			{
				dataAttribute: 'asset-color-code',
				attributeValue: value.colorCode,
				dataRelation: '='
			}
		], surfaceCtx);

		if ( colorCtx.length > 0 ) {
			setActiveColor(colorCtx);
		} else {
			missing.push({
				type: 'component',
				component: componentCtx.data('component-slug')
			});
		}
	});

	updateConfiguratorAfterRestoreConfiguration();

	if ( missing.length > 0 ) {
		displayLoading(false, null);
		showBrokenConfigurationMessage();
	}
}



/**
 * Effettua il restore di una configurazione a partire da un JSON.
 * A questo punto dell'elaborazione è già stato caricato il modello di penna corretto e la relativa configurazione di default.
 * Restano da personalizzare le finiture/colori dei componenti e le aree di stampa.
 *
 * L'oggetto JSON "jsonConfiguration" ha la seguente struttura:
 *    {
 *       "productCode":"DS3 TFF",
 *       "penModelName":"DS3",
 *       "penModelId":420,
 *       "components":[
 *          {
 *             "componentLabel":"Pen",
 *             "componentId":561,
 *             "surfaceCode":"F",
 *             "surfaceId":563,
 *             "colorCode":"F50"
 *           },
 *           {...}
 *       ],
 *       "writingSystem":
 *          {
 *             "refillLabel":"Floating Ball® Metal",
 *             "refillId":199,
 *             "optionId":1,
 *             "colorName":"Blue",
 *             "ballDiameter":"1.0"
 *          },
 *       "moq":500
 *    }
 *
 *
 * L'oggetto JSON "jsonExtendedConfiguration" ha la seguente struttura:
 *    {
 *      "imprint":[
 *         {
 *            "areaLabel":"Clip",
 *            "areaId":560,
 *            "areaCode":"B",
 *            "dataType":"text",
 *            "dataContent":
 *               {
 *                  "text":"test ",
 *                  "fontFamily":"Arial, Helvetica, sans-serif",
 *                  "fontSize":22,
 *                  "fontWeight":"normal",
 *                  "fontStyle":"normal",
 *                  "fontColor":"#ffffff",
 *                  "textAlign":"center",
 *                  "textRotation":270
 *               }
 *         },
 *         {...},
 *         {
 *            "areaLabel":"Body",
 *            "areaId":688,
 *            "areaCode":"D",
 *            "dataType":"image",
 *            "dataContent":
 *               {
 *                  "base64":"...",
 *               }
 *         }
 *      ]
 *   }
 *
 * @param {string} jsonConfiguration         : oggetto con i dati della penna
 * @param {string} jsonExtendedConfiguration : oggetto con i dati delle aree di stampa
 *
 * @since 1.0.0
 */
function restoreJSONConfiguration(jsonConfiguration, jsonExtendedConfiguration) {
	var cfg        = JSON.parse(jsonConfiguration);
	var cfgExt     = JSON.parse(jsonExtendedConfiguration);
	var missing    = [];
	var components = cfg.components;

	jQuery.each(components, function(index, value) {
		var componentId  = value.componentId;
		var surfaceId    = ( value.hasOwnProperty('surfaceId') ) ? value.surfaceId : value.finishingId;
		var colorCode    = value.colorCode;
		var componentCtx = getComponentCtxByDataAttribute([
			{
				dataAttribute: 'component-id',
				attributeValue: componentId,
				dataRelation: '='
			}
		]);
		var surfaceCtx   = getSurfaceCtxByDataAttribute([
			{
				dataAttribute: 'surface-id',
				attributeValue: surfaceId,
				dataRelation: '='
			}
		], false, componentCtx);

		if ( colorCode.length > 1 ) {
			var colorCtx = getColorCtxByDataAttribute([
				{
					dataAttribute: 'asset-color-code',
					attributeValue: colorCode,
					dataRelation: '='
				}
			], surfaceCtx);
		} else {
			// ATTENZIONE
			// I vecchi codici colore delle superfici Satin e Chrome erano "S" e "C", mentre ora sono del tipo "S70" e "C70".
			// Il colore potrebbe quindi esistere, ma avere una dicitura diversa.
			var colorCtx = getColorCtxByDataAttribute([
				{
					dataAttribute: 'asset-color-code',
					attributeValue: colorCode + '70',
					dataRelation: '='
				}
			], surfaceCtx);
		}

		if ( componentCtx.length == 0 ) {
			missing.push({
				type: 'component',
				component: value.componentLabel
			});
		} else {
			if ( colorCtx.length > 0 ) {
				setActiveColor(colorCtx);
			} else {
				missing.push({
					type: 'componentColor',
					component: value.componentLabel,
					color: colorCode
				});
			}
		}
	});

	if ( cfg.hasOwnProperty('writingSystem') ) {
		var refillId           = cfg.writingSystem.refillId;
		var optionId           = cfg.writingSystem.optionId;
		var ballDiameter       = cfg.writingSystem.ballDiameter;
		var refillColor        = cfg.writingSystem.refillColorCode;
		var refillOptionsCtx   = getRefillOptionsCtx();
		var refillCtx          = getRefillCtx(refillId, refillOptionsCtx);
		var inkColorsCtx       = getInkColorOptionsCtx(refillOptionsCtx, refillId);
		var inkColorCtx        = getInkColorCtxByDataAttribute(refillId, [
			{
				dataAttribute: 'option',
				attributeValue: optionId,
				dataRelation: '='
			}
		], refillOptionsCtx);
		var diameterOptionsCtx = getRefillDiameterOptionsCtx(refillOptionsCtx, refillId);
		var diametersCtx       = getRefillDiameterOptionCtx(optionId, '=', diameterOptionsCtx);
		var extraOptionsCtx    = getRefillExtraOptionsCtx(refillOptionsCtx, refillId);

		if ( refillCtx.length > 0 ) {
			refillCtx.prop('checked', true);

			if ( inkColorCtx.length > 0 ) {
				jQuery('li', inkColorsCtx).removeClass('active');
				inkColorCtx.addClass('active');

				var diameterCtx = ( !is_defined(ballDiameter) ) ? jQuery('.active input[type="radio"]', diameterCtx) : getRefillDiameterCtx(ballDiameter, diameterCtx);

				if ( diameterCtx.length > 0 ) {
					diameterCtx.prop('checked', true);
				} else {
					missing.push({
						type: 'refillDiameter',
						refillType: cfg.writingSystem.refillLabel,
						diameter: cfg.writingSystem.ballDiameter
					});
				}
			} else {
				missing.push({
					type: 'refillInkColor',
					refillType: cfg.writingSystem.refillLabel,
					inkColor: cfg.writingSystem.colorName
				});
			}

			if ( extraOptionsCtx.length > 0 ) {
				var refillColorsCtx = getRefillColorOptionsCtx(extraOptionsCtx, refillId);
				var refillColorCtx  = getRefillColorCtxByDataAttribute(refillId, [
					{
						dataAttribute: 'color-code',
						attributeValue: refillColor,
						dataRelation: '='
					}
				], refillColorsCtx);

				if (refillColorCtx.length > 0) {
					jQuery('li', refillColorsCtx).removeClass('active');
					refillColorCtx.addClass('active');
				} else {
					missing.push({
						type: 'refillColor',
						refillType: cfg.writingSystem.refillLabel,
						color: cfg.writingSystem.refillColorCode
					});
				}
			}
		} else {
			missing.push({
				type: 'refillType',
				refillType: cfg.writingSystem.refillLabel
			});
		}
	}

	var imprint = cfgExt.imprint;

	jQuery.each(imprint, function(index, value) {
		var areaId       = value.areaId;
		var dataType     = value.dataType;
		var dataContent  = value.dataContent;
		var topOffset    = is_defined(value.topOffset) ? value.topOffset : '';
		var printAreaCtx = jQuery('.print-area[data-area-id="' + areaId + '"]');

		if (printAreaCtx.length > 0) {
			if ( 'text' == dataType ) {
				var text         = dataContent.text;
				var fontFamily   = dataContent.fontFamily.replace(/"/g, "");
				var fontSize     = dataContent.fontSize;
				var fontWeight   = dataContent.fontWeight;
				var fontStyle    = dataContent.fontStyle;
				var fontColor    = dataContent.fontColor;
				var textAlign    = dataContent.textAlign;
				var textRotation = dataContent.textRotation;

				appendText(areaId, text, fontFamily, fontSize, fontWeight, fontStyle, fontColor, textAlign, textRotation);
			} else {
				var base64       = dataContent.base64;

				appendImage(areaId, base64, null);
				jQuery('.imprint-panel .tab-pane[data-area-id="' + areaId + '"] .btn-remove-container').show();
			}

			if ( topOffset != '' ) {
				jQuery('.print-area[data-area-id="' + areaId + '"]').each(function(index, element) {
					jQuery(element).css('top', topOffset);
				});

				jQuery.each(jQuery('.move-area input[name="move-area"]'), function(index, element) {
					var that = jQuery(element);

					if ( jQuery.number(that.attr('data-top-offset'), 3, ".", "") == jQuery.number(topOffset.replace('px', ''), 3, ".", "") ) {
						that.parent().trigger('click');
					}
				});
			}
		} else {
			missing.push({
				type: 'printArea',
				printArea: value.areaLabel
			});
		}
	});

	if ( cfg.qrcode ) {
		QRCodeEnabled = true;
	}

	updateConfiguratorAfterRestoreConfiguration();

	if ( missing.length > 0 ) {
		displayLoading(false, null);
		showBrokenConfigurationMessage();
	}
}



/**
 * Ripristina una configurazione a partire da un URL.
 * Ad esempio:
 *    - ?surface=ab&color=abn02
 *    - ?surface=f&color=f02&option=metal
 *
 * @param {object} args         : oggetto con i parametri principali per ricostruire una configurazione (codice superficie, codice colore, eventuali opzioni di personalizzazione)
 * @param {object} extendedArgs : oggetto con i parametri aggiuntivi (colori alternativi, "1" per nascondere le superfici non attive del componente principale )
 *
 * @since 1.1.0
 */
function restoreProductConfiguration(args, extendedArgs) {
	var surfaceCode         = args.surface;
	var colorCode           = args.color;
	var option              = args.option;
	var alternativeColors   = extendedArgs.altColor;
	var subset              = extendedArgs.subset;
	var msg                 = extendedArgs.msg;
	var primaryComponentCtx = getPrimaryComponentCtx();
	var surfaceCtx          = getSurfaceCtxByDataAttribute([
			{
				dataAttribute: 'surface-code',
				attributeValue: surfaceCode.toUpperCase(),
				dataRelation: '='
			}
		], false, primaryComponentCtx);
	var colorCtx            = getColorCtxByDataAttribute([
		{
			dataAttribute: 'asset-color-code',
			attributeValue: colorCode.toUpperCase(),
			dataRelation: '='
		}
	], surfaceCtx);

	if ( surfaceCtx.length > 0 && colorCtx.length > 0 ) {
		setActiveColor(colorCtx);
		updateComponentsSurfaces(surfaceCtx.data('surface-code'), colorCtx.data('asset-color-code'), colorCtx.data('alternative-color'));

		if ( is_defined(alternativeColors) && null != alternativeColors ) {
			var pairsKeyValue = alternativeColors.split(',');

			jQuery.each(pairsKeyValue, function(index, element) {
				var keyValue      = element.split('|');
				var componentSlug = keyValue[0];
				var colorCode     = keyValue[1].toUpperCase();

				var componentCtx  = getComponentCtxByDataAttribute([
					{
						dataAttribute: 'component-slug',
						attributeValue: componentSlug,
						dataRelation: '='
					}
				]);
				var colorCtx      = getColorCtxByDataAttribute([
					{
						dataAttribute: 'asset-color-code',
						attributeValue: colorCode.toUpperCase(),
						dataRelation: '='
					}
				], componentCtx);

				setActiveColor(colorCtx);
			});
		}

		if ( is_defined(option) && null != option ) {
			switch (option) {
				case 'metal':
					var optionClass = 'metal-option';

					selectOption(optionClass, false, function() {
						updateConfiguratorAfterRestoreConfiguration();
					});
					break;
			}
		}

		if ( is_defined(subset) && null != subset ) {
			var primaryComponentCtx = getPrimaryComponentCtx();
			var surfacesCtx         = getComponentSurfacesCtx(primaryComponentCtx, true);
			var activeSurfaceCtx    = getActiveSurfaceCtx(primaryComponentCtx).attr('data-visible', 'true');

			updateConfiguratorAfterRestoreConfiguration();

			jQuery.each(surfacesCtx, function(srfIndex, srfElement) {
				// checkSurfaceCompatibility([activeSurfaceCtx.data('surface-code')], primaryComponentCtx, jQuery(srfElement));

				if ( jQuery(srfElement).data('surface-code') != activeSurfaceCtx.data('surface-code') ) {
					jQuery(srfElement).attr('data-visible', 'false').hide();
				}
			});

			activeSurfaceCtx.parent().addClass('last');

			if ( is_defined(msg) && null != msg ) {
				var componentsCtx       = getComponentCtxByDataAttribute([
					{
						dataAttribute: 'component-type',
						attributeValue: 'optional',
						dataRelation: '!='
					}
				]);

				jQuery('.standard-message-container .standard-message', componentsCtx).html(minerva_configurator_vars.subset_message);
				componentsCtx.addClass('with-message');
			}
		} else {
			updateConfiguratorAfterRestoreConfiguration();
		}

		displayLoading(false, null);
	} else {
		displayLoading(false, null);
		showBrokenConfigurationMessage();
	}
}



/**
 * Ripristina una configurazione.
 *
 * @param {string} configuration : coppie chiave-valore separate da virgole; es. "bod|r75,cli|t53,but|t53"
 * @param {string} restricted    : es. "bod", "bod,cap"
 *
 * @since 1.1.0
 */
function restoreHomeConfiguration(configuration, restricted) {
	var pairsKeyValue    = configuration.split(',');
	var restrictedValues = ('' != restricted) ? restricted.split(',') : [];
	var primaryComponent = {};
	var otherComponents  = [];

	jQuery.each(pairsKeyValue, function(index, element) {
		var keyValue      = element.split('|');
		var componentSlug = keyValue[0];
		var colorCode     = keyValue[1].toUpperCase();
		var componentCtx  = getComponentCtxByDataAttribute([
			{
				dataAttribute: 'component-slug',
				attributeValue: componentSlug,
				dataRelation: '='
			}
		]);
		var colorCtx      = getColorCtxByDataAttribute([
			{
				dataAttribute: 'asset-color-code',
				attributeValue: colorCode,
				dataRelation: '='
			}
		], componentCtx);
		var surfaceCtx    = getSurfaceCtx(colorCtx);
		var component     = {
			componentId: componentCtx.data('component-id'),
			surfaceId: surfaceCtx.data('surface-id'),
			surfaceCode: surfaceCtx.data('surface-code'),
			colorCode: colorCtx.data('asset-color-code'),
			alternativeColor: colorCtx.data('alternative-color')
		};

		if ( 0 == index ) {
			primaryComponent = component;

			setActiveColor(colorCtx);
		} else {
			otherComponents.push(component);
		}
	});

	updateComponentsSurfaces(primaryComponent.surfaceCode, primaryComponent.colorCode, primaryComponent.alternativeColor);

	jQuery.each(otherComponents, function(index, element) {
		var componentCtx = getComponentCtxByDataAttribute([
			{
				dataAttribute: 'component-id',
				attributeValue: element.componentId,
				dataRelation: '='
			}
		]);
		var surfaceCtx   = getSurfaceCtxByDataAttribute([
			{
				dataAttribute: 'surface-id',
				attributeValue: element.surfaceId,
				dataRelation: '='
			}
		], false, componentCtx);
		var colorCtx     = getColorCtxByDataAttribute([
			{
				dataAttribute: 'asset-color-code',
				attributeValue: element.colorCode,
				dataRelation: '='
			}
		], surfaceCtx);

		setActiveColor(colorCtx);
	});

	updateConfiguratorAfterRestoreConfiguration();

	if ( restrictedValues.length > 0 ) {
		jQuery.each(restrictedValues, function(index, element) {
			var componentCtx     = getComponentCtxByDataAttribute([
				{
					dataAttribute: 'component-slug',
					attributeValue: element,
					dataRelation: '='
				}
			]);
			var activeSurfaceCtx = getActiveSurfaceCtx(componentCtx);
			var surfacesCtx      = getComponentSurfacesCtx(componentCtx, true);

			jQuery.each(surfacesCtx, function(srfIndex, srfElement) {
				checkSurfaceCompatibility([activeSurfaceCtx.data('surface-code')], componentCtx, jQuery(srfElement));
			});
		});

		reorderComponentsOptions();
	}

	displayLoading(false, null);
}



/**
 * Recupera il codice della superficie a partire dell'ID del componente.
 *
 * @param  {int} componentId :
 *
 * @return {string}
 *
 * @since 1.1.0
 */
function getSurfaceCodeByComponentId(componentId) {
	var componentCtx = getComponentCtxByDataAttribute([
		{
			dataAttribute: 'component-id',
			attributeValue: componentId,
			dataRelation: '='
		}
	]);

	return getActiveSurfaceCtx(componentCtx).data('surface-code');
}



/**
 * Restituisce il codice prodotto.
 *
 * @since 1.0.0
 */
function getProductCode() {
	var productCode = '';
	var suffixText  = '';

	if ( productCodeRules ) {
		var standard   = productCodeRules.standard;
		var optional   = productCodeRules.optional;
		var suffix     = productCodeRules.suffix;

		productCode   += productCodeRules.writing_system;

		if ( standard.length > 0 ) {
			jQuery.each(standard, function(index, element) {
				productCode += applyRule('standard', element);
			});
		}

		if ( optional.length > 0 ) {
			var temp = '';

			jQuery.each(optional, function(index, element) {
				temp        += applyRule('optional', element);
			});

			if ( '' != temp ) {
				productCode += '-' + temp;
			}
		}

		if ( suffix.length > 0 ) {
			jQuery.each(suffix, function(suffixIndex, suffixElement) {
				var checkConditions = true;
				var conditions      = suffixElement.conditions;
				var text            = suffixElement.suffix_text;

				jQuery.each(conditions, function(conditionIndex, conditionElement) {
					var componentCtx = getComponentCtxByDataAttribute([
						{
							dataAttribute: 'component-id',
							attributeValue: conditionElement.component_id,
							dataRelation: '='
						}
					]);
					var surfaceCtx   = getActiveSurfaceCtx(componentCtx);
					var surfaceId    = surfaceCtx.data('surface-id');
					var surfaceIds   = jQuery.map(conditionElement.surface_id, function(value) {
						return parseInt(value);
					});

					checkConditions  = ( jQuery.inArray(surfaceId, surfaceIds) > -1 );
				});

				if ( checkConditions ) {
					suffixText += ( '' != text ) ? ' ' + text : text;
				}
			});
		}
	}

	return productCode + suffixText;
}



/**
 * Applica una singola regola relativa alla composizione del codice prodotto.
 *
 * @param  {string} ruleType : accetta "standard" o "optional"
 * @param  {object} rule     :
 *
 * @return {string}
 *
 * @since 1.1.0
 */
function applyRule(ruleType, rule) {
	var returnString = '';

	if ( 'component' in rule ) {
		var surfaceCode = getSurfaceCodeByComponentId(rule.component);

		if ( 'standard' == ruleType
			 || ( 'optional' == ruleType
				  && surfaceCode.indexOf(dummy_surface_code) == -1 ) ) {
			returnString = surfaceCode;
		}
	}

	if ( 'fixed' in rule ) {
		returnString = rule.fixed;
	}

	if ( 'mixed' in rule ) {
		jQuery.each(rule.mixed, function(mixedIndex, mixedElement) {
			var checkConditions = true;
			var conditions      = mixedElement.conditions;

			jQuery.each(conditions, function(conditionIndex, conditionElement) {
				var componentCtx = getComponentCtxByDataAttribute([
					{
						dataAttribute: 'component-id',
						attributeValue: conditionElement.component_id,
						dataRelation: '='
					}
				]);
				var surfaceCtx   = getActiveSurfaceCtx(componentCtx);
				var surfaceId    = surfaceCtx.data('surface-id');
				var surfaceIds   = jQuery.map(conditionElement.surface_id, function(value) {
					return parseInt(value);
				});

				checkConditions  = ( jQuery.inArray(surfaceId, surfaceIds) > -1 );
			});

			if ( checkConditions ) {
				if ( '' != mixedElement.surface_code ) {
					returnString = mixedElement.surface_code;
				} else if ( '' != mixedElement.component_id ) {
					var surfaceCode = getSurfaceCodeByComponentId(mixedElement.component_id);

					if ( surfaceCode.indexOf(dummy_surface_code) == -1 ) {
						if ( mixedElement.use_color_code ) {
							var componentCtx = getComponentCtxByDataAttribute([
								{
									dataAttribute: 'component-id',
									attributeValue: mixedElement.component_id,
									dataRelation: '='
								}
							]);
							var colorCode = getActiveColorCtx(componentCtx).data('color-code');

							returnString = colorCode.replace(/\d+/g, '');
						} else {
							returnString = surfaceCode;
						}
					}
				}
			}
		});
	}

	return returnString;
}



/**
 * Recupera il contesto dei componenti.
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getComponentsCtx() {
	return jQuery('.component-options[data-component-type!="null"]');
}



/**
 * Recupera il contesto di un componente a partire da un elemento figlio.
 *
 * @param  {selector} childElement
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getComponentCtx(childElement) {
	return jQuery(childElement).closest('.component-options');
}



/**
 * Recupera il contesto del componente principale.
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getPrimaryComponentCtx() {
	return getComponentCtxByDataAttribute([
		{
			dataAttribute: 'component-type',
			attributeValue: 'primary',
			dataRelation: '='
		}
	]);
}



/**
 * Recupera il contesto di un componente tramite data-attribute.
 *
 * @param  {array} args       : array di oggetti, che specificano il nome dell'attributo, il valore e la relazione
 * @param  {bool}  excludeRef : "false" per considerare anche il pannello dei refill
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getComponentCtxByDataAttribute(args, excludeRef) {
	var selector = '.component-options';

	jQuery.each(args, function(index, value) {
		selector += '[data-' + value.dataAttribute + value.dataRelation + '"' + value.attributeValue + '"]';
	});

	if ( !is_defined(excludeRef) || excludeRef ) {
		selector += '[data-component-type!="null"]';
	}

	return jQuery(selector);
}



/**
 * Recupera il contesto del componente attivo.
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getActiveComponentCtx() {
	return jQuery('.component-options.active');
}



/**
 * Recupera il contesto di una superficie a partire da un elemento figlio.
 *
 * @param  {selector} childElement
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getSurfaceCtx(childElement) {
	return jQuery(childElement).closest('.surface-container');
}



/**
 * Recupera il contesto della superficie attiva di un dato componente.
 *
 * @param  {selector} componentCtx
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getActiveSurfaceCtx(componentCtx) {
	return jQuery('.surface-container.active', componentCtx);
}



/**
 * Recupera il contesto di una superficie tramite data-attribute.
 *
 * @param  {array}    args   : array di oggetti, che specificano il nome dell'attributo, il valore e la relazione
 * @param  {bool}     active : "true" per recuperare la superficie attiva, altrimenti "false"
 * @param  {selector} ctx    : contesto
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getSurfaceCtxByDataAttribute(args, active, ctx) {
	var selector = '.surface-container';

	if ( is_defined(active) && active ) {
		selector += '.active';
	}

	jQuery.each(args, function(index, value) {
		selector += '[data-' + value.dataAttribute + value.dataRelation + '"' + value.attributeValue + '"]';
	});

	return jQuery(selector, ctx);
}



/**
 * Recupera tutti i contesti delle superifici di un dato componente.
 * Eventualmente limita i risultati alle superfici non attive.
 *
 * @param  {selector} componentCtx :
 * @param  {bool}     notActive    : "true" per recuperare tutte le superfici non attive di un dato componente
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getComponentSurfacesCtx(componentCtx, notActive) {
	if ( is_defined(notActive) && notActive) {
		return jQuery('.surface-container:not(.active)', componentCtx);
	} else {
		return jQuery('.surface-container', componentCtx);
	}
}



/**
 * Recupera il contesto del colore.
 *
 * @param  {selector} ctx    : può essere un contesto superficie o un contesto componente
 * @param  {bool}     active : "true" per recuperare il colore attivo, "false" per i colori non attivi. Se non viene espressamente definito recupera tutti i colori
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getColorCtx(ctx, active) {
	if ( is_defined(active) ) {
		if ( active ) {
			return jQuery('.colors-list .color-item.active', ctx);
		} else {
			return jQuery('.colors-list .color-item:not(.active)', ctx);
		}
	} else {
		return jQuery('.colors-list .color-item', ctx);
	}
}



/**
 * Recupera il contesto del colore attivo.
 *
 * @param  {selector} ctx : può essere un contesto superficie o un contesto componente
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getActiveColorCtx(ctx) {
	return getColorCtx(ctx, true);
}



/**
 * Recupera il contesto del colore tramite data-attribute.
 *
 * @param  {array}    args : array di oggetti, che specificano il nome dell'attributo, il valore e la relazione
 * @param  {selector} ctx
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getColorCtxByDataAttribute(args, ctx) {
	var selector = '.colors-list .color-item';

	jQuery.each(args, function(index, value) {
		selector += '[data-' + value.dataAttribute + value.dataRelation + '"' + value.attributeValue + '"]';
	});

	return jQuery(selector, ctx);
}



/**
 * Recupera il contesto della palette di colori a partire ad un elemento figlio.
 *
 * @param  {selector} childElement
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getColorPaletteCtx(childElement) {
	return jQuery(childElement).closest('.colors-list');
}



/**
 * Recupera il contesto dei selettori delle aree di stampa tramite data-attribute.
 *
 * @param  {array}    args : array di oggetti, che specificano il nome dell'attributo, il valore e la relazione
 * @param  {selector} ctx  :
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getPrintAreaTabCtxByDataAttribute(args, ctx) {
	var selector = '.nav-link';

	if ( !is_defined(ctx) ) {
		ctx = '#v-pills-printareas-tab';
	}

	jQuery.each(args, function(index, value) {
		selector += '[data-' + value.dataAttribute + value.dataRelation + '"' + value.attributeValue + '"]';
	});

	return jQuery(selector, ctx);
}

/* Versione smartphone */
function getPrintAreaTabDropdownCtxByDataAttribute(args, ctx) {
	var selector = 'option';

	if ( !is_defined(ctx) ) {
		ctx = '.nav-pills-printareas-tab-dropdown';
	}

	jQuery.each(args, function(index, value) {
		selector += '[data-' + value.dataAttribute + value.dataRelation + '"' + value.attributeValue + '"]';
	});

	return jQuery(selector, ctx);
}



/**
 * Recupera il contesto del selettore dell'area di stampa attivo.
 *
 * @param  {selector} ctx :
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getActivePrintAreaTabCtx(ctx) {
	var selector = '.nav-link.active';

	if ( !is_defined(ctx) ) {
		ctx = '#v-pills-printareas-tab';
	}

	return jQuery(selector, ctx);
}



/**
 * Recupera il contesto del primo selettore dell'area di stampa disponibile.
 *
 * @param  {selector} ctx :
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
/* Versione smartphone */
function getPrintAreaFirstAvailableOptionCtx(ctx) {
	var selector = 'option[data-visible="true"]';

	if ( !is_defined(ctx) ) {
		ctx = '.nav-pills-printareas-tab-dropdown';
	}

	return jQuery(selector, ctx).first();
}



/**
 * Recupera il contesto dello switch "Remove option".
 *
 * @param  {selector} ctx :
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getRemoveOptionSwitch(ctx) {
	var selector = '.remove-option-switch';

	return jQuery(selector, ctx);
}



/**
 * Recupera il contesto delle opzioni dei refill.
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getRefillOptionsCtx() {
	return getComponentCtxByDataAttribute([
		{
			dataAttribute: 'component-id',
			attributeValue: '0',
			dataRelation: '='
		}
	], false);
}



/**
 * Recupera il contesto di un dato refilld.
 *
 * @param  {int}      refillId :
 * @param  {selector} ctx      :
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getRefillCtx(refillId, ctx) {
	if ( !is_defined(ctx) ) {
		ctx = getRefillOptionsCtx();
	}

	if ( refillId > 0 ) {
		return jQuery('.refill-radio input[name="refill"][data-refill-id="' + refillId + '"]', ctx);
	} else {
		return jQuery('.refill-radio input[name="refill"]', ctx);
	}
}



/**
 * Recupera il contesto superiore di un refill.
 *
 * @param  {selector} childElement :
 * @param  {string}   needleClass  : classe CSS per idendificare l'elemento da cercare all'interno della gerarchia; accetta "parent" o "ancestor"
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getRefillContainerCtx(childElement, needleClass) {
	if ( !is_defined(childElement) && !is_defined(needleClass) ) {
		return jQuery('.writing-system-container');
	} else {
		switch ( needleClass ) {
			case 'parent':
				return jQuery(childElement).closest('.writing-system-container');
				break;
			case 'ancestor':
				return jQuery(childElement).closest('.writing-system-wrapper');
				break;
		}
	}
}



/**
 * Recupera il contesto del refill selezionato.
 *
 * @param  {selector} ctx :
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getSelectedRefillCtx(ctx) {
	return jQuery('.refill-radio input[name="refill"]:checked', ctx);
}



/**
 * Recupera il contesto delle opzioni colore dell'inchiostro.
 * Eventualmente limita i risultati ad un determinato refill.
 *
 * @param  {selector} ctx      :
 * @param  {int}      refillId :
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getInkColorOptionsCtx(ctx, refillId) {
	if ( is_defined(refillId) ) {
		return jQuery('.ink-colors-list[data-refill-id="' + refillId + '"]', ctx);
	} else {
		return jQuery('.ink-colors-list', ctx);
	}
}



/**
 * Recupera il contesto del colore dell'inchiostro a partire da un elemento figlio.
 *
 * @param  {selector} childElement :
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getInkColorCtx(childElement) {
	return jQuery(childElement).closest('.ink-colors-list');
}



/**
 * Recupera il contesto del colore dell'inchiostro attivo.
 *
 * @param  {selector} ctx :
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getActiveInkColorCtx(ctx) {
	return jQuery('.active', ctx);
}



/**
 * Recupera il contesto del colore dell'inchiostro tramite data-attribute.
 *
 * @param  {int}      refillId :
 * @param  {array}    args     : array di oggetti, che specificano il nome dell'attributo, il valore e la relazione
 * @param  {selector} ctx      :
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getInkColorCtxByDataAttribute(refillId, args, ctx) {
	if ( !is_defined(ctx) ) {
		ctx = getRefillOptionsCtx();
	}

	var inkColorsCtx = getInkColorOptionsCtx(ctx, refillId);
	var selector     = 'li';

	jQuery.each(args, function(index, value) {
		selector += '[data-' + value.dataAttribute + value.dataRelation + '"' + value.attributeValue + '"]';
	});

	return jQuery(selector, ctx);
}



/**
 * Recupera il contesto delle opzioni diametro dei refill.
 * Eventualmente limita i risultati ad un determinato refill.
 *
 * @param  {selector} ctx      :
 * @param  {int}      refillId :
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getRefillDiameterOptionsCtx(ctx, refillId) {
	if ( is_defined(refillId) ) {
		return jQuery('.ball-diameter-radio-wrapper[data-refill-id="' + refillId + '"]', ctx);
	} else {
		return jQuery('.ball-diameter-radio-wrapper', ctx);
	}
}



/**
 * Recupera il contesto delle opzioni diametro associate ad un dato refill e un dato colore di inchiostro (data-option).
 *
 * @param  {string}   option  :
 * @param  {string}   compare :
 * @param  {selector} ctx     :
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getRefillDiameterOptionCtx(option, compare, ctx) {
	return jQuery('.ball-diameter-radio-container[data-option' + compare + '"' + option + '"]', ctx);
}



/**
 * Recupera il contesto del diametro.
 *
 * @param  {string}   diameter :
 * @param  {selector} ctx      :
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getRefillDiameterCtx(diameter, ctx) {
	return jQuery('.ball-diameter-radio input[type="radio"][value="' + diameter + '"]', ctx);
}



/**
 * Recupera il contesto del diametro selezionato.
 *
 * @param  {selector} ctx :
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getSelectedDiameterCtx(ctx) {
	return jQuery('.ball-diameter-radio input[name^="diameter"]:checked', ctx).closest('.ball-diameter-radio');
}



/**
 * Recupera il contesto delle opzioni extra dei refill.
 * Eventualmente limita i risultati ad un dato refill.
 *
 * @param  {selector} ctx      :
 * @param  {int}      refillId :
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getRefillExtraOptionsCtx(ctx, refillId) {
	if ( is_defined(refillId) ) {
		return jQuery('.refill-extra-options[data-refill-id="' + refillId + '"]', ctx);
	} else {
		return jQuery('.refill-extra-options', ctx);
	}
}



/**
 * Recupera il contesto delle opzioni colore dei refill.
 * Eventualmente limita i risultati ad un dato refill.
 *
 * @param  {selector} ctx      :
 * @param  {int}      refillId :
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getRefillColorOptionsCtx(ctx, refillId) {
	if ( is_defined(refillId) ) {
		return jQuery('.refill-colors-list[data-refill-id="' + refillId + '"]', ctx);
	} else {
		return jQuery('.refill-colors-list', ctx);
	}
}



/**
 * Recupera il contesto del colore del refill tramite data-attribute.
 *
 * @param  {int}      refillId :
 * @param  {array}    args     : array di oggetti, che specificano il nome dell'attributo, il valore e la relazione
 * @param  {selector} ctx      :
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getRefillColorCtxByDataAttribute(refillId, args, ctx) {
	if ( !is_defined(ctx) ) {
		ctx = getRefillExtraOptionsCtx(getRefillOptionsCtx(), refillId)
	}

	var refillColorsCtx = getRefillColorOptionsCtx(ctx, refillId);
	var selector        = 'li';

	jQuery.each(args, function(index, value) {
		selector += '[data-' + value.dataAttribute + value.dataRelation + '"' + value.attributeValue + '"]';
	});

	return jQuery(selector, ctx);
}



/**
 * Recupera il contesto del colore del refill a partire da un elemento figlio.
 *
 * @param  {selector} childElement :
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getRefillColorCtx(childElement) {
	return jQuery(childElement).closest('.refill-colors-list');
}



/**
 * Recupera il contesto del colore attivo del refill.
 *
 * @param  {selector} ctx :
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getActiveRefillColorCtx(ctx) {
	return jQuery('.active', ctx);
}



/**
 * Recupera il contesto principale delle aree di stampa.
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getImprintMainCtx() {
	return jQuery('#pills-imprint');
}



/**
 * Recupera il contesto delle aree di stampa.
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getPrintAreaTabsCtx() {
	return jQuery('#v-pills-printareas-tabContent');
}



/**
 * Recupera il contesto di un'area di stampa.
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getPrintAreaTypesTabCtx() {
	return jQuery('#nav-tabs-printareas-tabContent');
}



/**
 * Recupera il contesto di un'area di stampa a partire da un elemento figlio.
 *
 * @param  {selector} childElement :
 * @param  {string}   tabClass     : classe CSS per idendificare la tab all'interno della gerarchia; accetta "parent" o "ancestor"
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getPrintAreaTabCtx(childElement, tabClass) {
	if ( is_defined(tabClass) ) {
		return jQuery(childElement).closest('.tab-pane.' + tabClass + '-tab');
	} else {
		return jQuery(childElement).closest('.tab-pane');
	}
}



/**
 * Recupera il contesto genitore di un'area di stampa.
 *
 * @param  {selector} childElement :
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getPrintAreaParentTabCtx(childElement) {
	return getPrintAreaTabCtx(childElement, 'parent');
}



/**
 * Recupera il contesto progenitore di un'area di stampa.
 *
 * @param  {selector} childElement :
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getPrintAreaAncestorTabCtx(childElement) {
	return getPrintAreaTabCtx(childElement, 'ancestor');
}



/**
 * Recupera il contesto di un'area di stampa tramite un insieme di attributi.
 *
 * @param  {array}    args : array di oggetti, che specificano il typo di attributo ("id", "data-*", etc.), il valore e la relazione
 * @param  {selector} ctx :
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getPrintAreaTabCtxByAttribute(args, ctx) {
	var selector = '.tab-pane';

	if ( !is_defined(ctx) ) {
		ctx = getPrintAreaTabsCtx();
	}

	jQuery.each(args, function(index, value) {
		selector += '[' + value.attributeType + value.dataRelation + '"' + value.attributeValue + '"]';
	});

	return jQuery(selector, ctx);
}



/**
 * Recupera il contesto di selezione di un'immagine.
 *
 * @param  {selector} ctx :
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getImageSelectionCtx(ctx) {
	if ( is_defined(ctx) ) {
		return jQuery('.image-selection', ctx);
	} else {
		return jQuery('.image-selection');
	}
}



/**
 * Recupera il contesto dei filtri per l'elaborazione dell'immagine.
 *
 * @param  {selector} ctx :
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getImageFiltersCtx(ctx) {
	return jQuery('.image-filters', ctx);
}



/**
 * Recupera il contesto del fine-tuning per l'elaborazione dell'immagine.
 *
 * @param  {selector} ctx :
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getImageFineTuningCtx(ctx) {
	return jQuery('.image-fine-tuning', ctx);
}



/**
 * Recupera il contesto della griglia della history dei loghi.
 *
 * @param  {selector} ctx :
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getHistoryGridCtx(ctx) {
	if ( is_defined(ctx) ) {
		return jQuery('.logos-history .logos-grid', ctx);
	} else {
		return jQuery('.logos-history .logos-grid');
	}
}



/**
 * Recupera il contesto dei messaggi associati al file upload.
 *
 * @param  {selector} ctx :
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getNoticesCtx(ctx) {
	if ( is_defined(ctx) ) {
		return jQuery('.editor-body .notices-wrapper', ctx);
	} else {
		return jQuery('.editor-body .notices-wrapper');
	}
}



/**
 * Recupera il contesto dei messaggi associati alla history dei loghi.
 *
 * @param  {selector} ctx :
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getHistoryNoticesCtx(ctx) {
	if ( is_defined(ctx) ) {
		return jQuery('.editor-body .notices-wrapper', ctx);
	} else {
		return jQuery('.editor-body .notices-wrapper');
	}
}



/**
 * Recupera il contesto delle anteprime.
 *
 * @param  {string} tab :
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getPreviewCtx(tab) {
	if (tab) {
		return jQuery('.pen-preview.' + tab);
	} else {
		return jQuery('.pen-preview:not(.horizontal-view)');
	}
}



/**
 * Recupera il contesto dell'anteprima dell'area di stampa tramite data-attribute.
 *
 * @param  {array}    args : array di oggetti, che specificano il nome dell'attributo, il valore e la relazione
 * @param  {selector} ctx  :
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getPreviewPrintAreaCtxByDataAttribute(args, ctx) {
	var selector = '.print-area';

	if ( !is_defined(ctx) ) {
		ctx = getPreviewCtx();
	}

	jQuery.each(args, function(index, value) {
		selector += '[data-' + value.dataAttribute + value.dataRelation + '"' + value.attributeValue + '"]';
	});

	return jQuery(selector, ctx);
}



/**
 * Recupera il contesto del contenuto dell'anteprima di un'area di stampa.
 *
 * @param  {selector} ctx :
 *
 * @return {selector}
 *
 * @since 1.1.0
 */
function getPreviewPrintAreaContentCtx(ctx) {
	return jQuery('.print-area-content', ctx);
}



/**
 * Recupera il nome del modello di penna.
 *
 * @param  {string} type : accetta "short" o "full"
 *
 * @return {string}
 *
 * @since 1.1.0
 */
function getModelName(type) {
	switch ( type ) {
		case 'short':
			return jQuery('.tech-specs.model .model', '#pills-recap').text().trim();
			break;
		case 'full':
			return jQuery('article.pen').data('model-name');
			break;
	}
}



/**
 * Recupera il nome breve del modello di penna.
 *
 * @return {string}
 *
 * @since 1.1.0
 */
function getModelShortName() {
	return getModelName('short');
}



/**
 * Recupera il nome completo del modello di penna.
 *
 * @return {string}
 *
 * @since 1.1.0
 */
function getModelFullName() {
	return getModelName('full');
}



/**
 * Recupera l'ID del modello di penna.
 *
 * @return {int}
 *
 * @since 1.1.0
 */
function getModelId() {
	return jQuery('article.pen').data('model-id');
}



/**
 * Recupera l'ID del termine della tassonomia (Drupal) corrispondente al modello di penna.
 * Campo "field_model".
 *
 * @return {int}
 *
 * @since 1.1.0
 */
function getModelTagName() {
	var tags = {
		'ds1': 141,
		'ds2': 142,
		'ds3': 143,
		'ds3fastlane': 143,
		'ds31': 144,
		'ds3biotic': 145,
		'ds4': 146,
		'ds5': 147,
		'ds5fastlane': 147,
		'ds7': 148,
		'ds8': 203,
		'ds8fastlane': 203,
		'ds8mc': 204,
		'ds9': 149,
		'qs01': 151,
		'qs03': 152,
		'qs20': 153,
		'qs30': 154,
		'qs40': 155,
		'qs40truebiotic': 156,
	}

	return tags[ getModelSlug() ];
}



/**
 * Recupera il codice prodotto completo.
 *
 * @return {string}
 *
 * @since 1.1.0
 */
function getFullProductCode() {
	return getModelShortName() + ' ' + getProductCode();
}



/**
 * Recupera lo slug del modello di penna.
 *
 * @return {string}
 *
 * @since 1.1.0
 */
function getModelSlug() {
	return jQuery('article.pen').data('slug');
}



/**
 * Effettua una reinizializzazione del configuratore.
 *
 * @since 1.1.0
 */
function updateConfiguratorAfterRestoreConfiguration() {
	var primaryComponentCtx     = getPrimaryComponentCtx();
	var primaryComponentId      = primaryComponentCtx.data('component-id');
	var primarySurfaceCtx       = getActiveSurfaceCtx(primaryComponentCtx);
	var primarySurfaceCode      = primarySurfaceCtx.data('surface-code');
	var primaryColorCtx         = getActiveColorCtx(primarySurfaceCtx)
	var primaryColorCode        = primaryColorCtx.data('asset-color-code');
	var primaryAlternativeColor = primaryColorCtx.data('alternative-color');
	var alternativeColors       = ( is_defined(primaryAlternativeColor) && primaryAlternativeColor != '' ) ? primaryAlternativeColor.split(',') : [];
	var componentsCtx           = getComponentCtxByDataAttribute([
		{
			dataAttribute: 'component-type',
			attributeValue: 'primary',
			dataRelation: '!='
		}
	]);

	componentsCtx.each(function(cmpIndex, cmpElement) {
		var componentCtx      = jQuery(cmpElement);
		var componentType     = componentCtx.data('component-type');
		var componentId       = componentCtx.data('component-id');
		var componentSlug     = componentCtx.data('component-slug');
		var surfaceCodes      = matches[primarySurfaceCode][componentId];
		var componentSurfaces = getComponentSurfacesCtx(componentCtx);

		componentSurfaces.each(function(srfIndex, srfElement) {
			var surfaceCtx = jQuery(srfElement);

			checkSurfaceCompatibility(surfaceCodes, componentCtx, surfaceCtx);
		});

		if ( 'optional' != componentType ) {
			jQuery('.color-message p[data-asset-color-code!="' + primaryColorCode + '"]', componentCtx).removeClass('active');
			jQuery('.color-message p[data-asset-color-code="' + primaryColorCode + '"]', componentCtx).addClass('active');

			MixAndMatch(primarySurfaceCode, componentCtx);
		} else {

		}

		showColorLegend(componentCtx);
	});

	ET1(true, primaryColorCtx);
	ET2(true, primaryColorCtx);
	ET4();
	removeOptionHandler();
	reorderComponentsOptions();
	updatePrintAreas();
	updateTextColorPalette();
	updateQRCodes(); // @since 2.0.0
	updateWritingSystemOptions();
	updateConfigurationRecap();
	refreshPreview();

	displayLoading(false, null);
}



/**
 * Mostra la modal che informa l'utente che non è stato possibile riprostinare completamente la configurazione salvata.
 *
 * @since 1.1.0
 */
function showBrokenConfigurationMessage() {
	jQuery('#broken-modal .modal-body .primary-content').html('<p class="text-secondary mb-0">' + minerva_common_vars.missing_configuration_data.generic_option_intro + '</p>');
	jQuery('#broken-modal .modal-body .secondary-content').append('<p class="text-secondary">' + minerva_common_vars.missing_configuration_data.generic_option +'</p>');
	jQuery('#broken-modal').modal('show');
}



/**
 * Genera il nome del file relativo all'asset da creare.
 *
 * @param  {string} suffix : stringa da aggiungere in coda al file (prima dell'indicazione della vista)
 *
 * @return {string}
 *
 * @since 1.1.0
 */
function setProductPreviewFileName(suffix) {
	var modelSlug           = getModelSlug();
	var primaryComponentCtx = getPrimaryComponentCtx();
	var primarySurfaceCtx   = getActiveSurfaceCtx(primaryComponentCtx);
	var primarySurfaceCode  = primarySurfaceCtx.data('surface-code').toLowerCase();
	var primaryColorCtx     = getActiveColorCtx(primarySurfaceCtx)
	var primaryColorCode    = primaryColorCtx.data('color-code').toLowerCase();
	var antibacterialCode   = 'ab';
	var fileName            = [];

	if ( antibacterialCode == primarySurfaceCode ) {
		// Modifico il codice della superficie nel caso la palette di colori contenga colori relativi a finiture diverse (es. DS3).
		// In questo caso il codice della superficie è pari al codice superficie del colore selezionato, seguito dalla lettera "a" (es. "pa" per "polished antibacterial").
		primarySurfaceCode = primaryColorCode.match(/[a-z]+/)[0].replace(antibacterialCode, '') + 'a';
	}

	// Dal codice colore rimuovo l'indicazione della superficie.
	primaryColorCode = primaryColorCode.match(/\d+/)[0];

	fileName.push(modelSlug);
	fileName.push(primarySurfaceCode);
	fileName.push(primaryColorCode);

	if ( '' != suffix ) {
		fileName.push(suffix);
	}

	return fileName.join('_');
}



/**
 * Richiama la funzione per creare l'immagine di anteprima di una configurazione.
 *
 * @param {string} suffix     : stringa da aggiungere in coda al file (prima dell'indicazione della vista)
 * @param {bool}   skipOption : true/false per bypassare la selezione delle opzioni
 *
 * @since 1.1.0
 */
function _createProductPreview(suffix, skipOption) {
	if ( '' != suffix ) {
		var optionClass;

		switch (suffix) {
			case 'metal':
				optionClass = 'metal-option';
				break;
		}

		if ( is_defined(skipOption) && skipOption ) {
			createProductPreview(
				suffix,
				function(response) {
					console.log(response.urls);

				},
				function(response) {
					console.log(response.message);
				}
			);
		} else {
			selectOption(optionClass, true, function() {
				createProductPreview(
					suffix,
					function(response) {
						console.log(response.urls);

					},
					function(response) {
						console.log(response.message);
					}
				)
			});
		}
	} else {
		createProductPreview(
			suffix,
			function(response) {
				console.log(response.urls);

			},
			function(response) {
				console.log(response.message);
			}
		);
	}
}



/**
 * Crea l'immagine di anteprima di una configurazione.
 *
 * @param {string}   suffix          : stringa da aggiungere in coda al file (prima dell'indicazione della vista)
 * @param {function} successCallback : funzione da eseguire in caso di successo
 * @param {function} errorCallback   : funzione da eseguire in caso di errore
 *
 * @since 1.1.0
 */
function createProductPreview(suffix, successCallback, errorCallback) {
	var deferredSave = jQuery.Deferred();
	var imagesBase64 = [];
	var imageFormat  = 'png';
	var start        = new Date().getTime();

	function renderImage(res, tpl, resize, imageFormat, imprint, viewCode, callback) {
		var renderImageDeferred = jQuery.Deferred();

		createPreviewTemplate(res, tpl, resize, imageFormat, imprint, viewCode, function(returnVal) {
			imagesBase64.push(returnVal);
			renderImageDeferred.resolve();
		});

		return renderImageDeferred.promise();
	}

	printProgress('', 'Rendering front-view image in progress');

	jQuery.when(renderImage('hi', false, 1, imageFormat, false, 'f')).done(function() {
		printProgress('', 'Rendering finished');
		printProgress('', 'Rendering side-view image in progress');

		jQuery.when(renderImage('hi', false, 1, imageFormat, false, 's')).done(function() {
			printProgress('', 'Rendering finished');
			printProgress('', 'Creating preview images in progress');

			var blobFront = base64ToBlob(imagesBase64[0]);
			var blobSide  = base64ToBlob(imagesBase64[1]);
			var fd        = new FormData();

			fd.append("action", 'minerva_create_product_preview');
			fd.append("frontViewImageFile", blobFront);
			fd.append("sideViewImageFile", blobSide);
			fd.append("fileName", setProductPreviewFileName(suffix));
			fd.append("configuration", getConfigurationData('shortObj'));
			fd.append("format", imageFormat);
			fd.append("_nonce", jQuery('#product_preview').val());

			jQuery.ajax({
				url: minerva_configurator_vars.ajaxurl,
				type: "POST",
				contentType: false,
				processData: false,
				cache: false,
				dataType: "json",
				data: fd,
				success: function(response) {
					deferredSave.resolve();

					if ( !response.error ) {
						printProgress(start, 'Preview images successfully created');

						successCallback(response);
					} else {
						errorCallback(response);
					}
				},
				error: function(xhrRequest, status, errorMessage)  {
					deferredSave.reject();

					console.log(xhrRequest);
					console.log(errorMessage);
				}
			});
		});
	});
}

function printProgress(start, message) {
	if ( '' == start ) {
		console.log(message);
	} else {
		var end     = new Date().getTime();
		var elapsed = end - start;

		console.log(message + ' (' + Math.round(elapsed / 1000) + ' sec)');
	}
}



/**
 * Seleziona determinate opzioni.
 *
 * @param {string}   optionClass  :
 * @param {bool}     triggerClick : "true" per eseguire il trigger('click'), altrimenti "false"
 * @param {function} callback     :
 *
 * @since 1.1.0
 */
function selectOption(optionClass, triggerClick, callback) {
	var componentsCtx = getComponentCtxByDataAttribute([
		{
			dataAttribute: 'component-type',
			attributeValue: 'primary',
			dataRelation: '!='
		}
	]);

	componentsCtx.each(function(cmpIndex, cmpElement) {
		var componentCtx = jQuery(cmpElement);
		var breakLoop    = false;
		var surfacesCtx  = getSurfaceCtxByDataAttribute([
			{
				dataAttribute: 'visible',
				attributeValue: 'true',
				dataRelation: '='
			}
		], false, componentCtx);

		surfacesCtx.each(function(srfIndex, srfElement) {
			if ( !breakLoop ) {
				var surfaceCtx = jQuery(srfElement);
				var colorsCtx  = getColorCtx(surfaceCtx);

				colorsCtx.each(function(index, element) {
					var colorCtx  = jQuery(element);

					if ( colorCtx.hasClass(optionClass) ) {
						if ( triggerClick ) {
							colorCtx.trigger('click');
						} else {
							setActiveColor(colorCtx);
						}

						breakLoop = true;
					}
				});
			}
		});
	});

	if ( is_defined(callback) && jQuery.isFunction(callback) ) {
		callback();
	}
}



/**
 * Convert a base64 string in a Blob according to the data and contentType.
 * Riferimento: http://stackoverflow.com/questions/16245767/creating-a-blob-from-a-base64-string-in-javascript
 *
 * @param  {string} base64    : base64 string
 * @param  {int}    sliceSize : slice size to process the byte characters
 *
 * @return {Blob}
 *
 * @since 1.1.1
 */
function base64ToBlob(base64, sliceSize) {
	var block          = base64.split(";");
	var contentType    = block[0].split(":")[1] || '';
	var b64Data        = block[1].split(",")[1];

	sliceSize          = sliceSize || 512;

	var byteCharacters = atob(b64Data);
	var byteArrays     = [];

	for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
		var slice       = byteCharacters.slice(offset, offset + sliceSize);
		var byteNumbers = new Array(slice.length);

		for (var i = 0; i < slice.length; i++) {
			byteNumbers[i] = slice.charCodeAt(i);
		}

		var byteArray = new Uint8Array(byteNumbers);

		byteArrays.push(byteArray);
	}

	var blob = new Blob(byteArrays, { type: contentType });

	return blob;
}



/**
 * Restituisce il codice colore da utilizzare per recuperare l'asset corretto.
 *
 * @param  {selector} colorCtx :
 *
 * @return {string}
 *
 * @since 1.2.0
 */
function getAssetColorCode(colorCtx) {
	var assetColorCode = colorCtx.data('asset-color-code');
	var placeholderId  = parseInt(colorCtx.data('placeholder-id'));

	if ( 0 == placeholderId ) {
		return assetColorCode;
	} else {
		var componentPlaceholderCtx = getComponentCtxByDataAttribute([
			{
				dataAttribute: 'component-id',
				attributeValue: placeholderId,
				dataRelation: '='
			}
		], true);
		var placeholderColorCtx     = getActiveColorCtx(componentPlaceholderCtx);
		var assetPlaceholder        = placeholderColorCtx.data('asset-placeholder');

		return ( '' != assetPlaceholder ) ? assetColorCode + '-' + assetPlaceholder : assetColorCode;
	}
}



/**
 * Recupera il contesto di selezione del QR code.
 *
 * @param  {selector} ctx :
 *
 * @return {selector}
 *
 * @since 2.0.0
 */
function getQRcodeSelectionCtx(ctx) {
	if ( is_defined(ctx) ) {
		return jQuery('.qrcode-selection', ctx);
	} else {
		return jQuery('.qrcode-selection');
	}
}



/**
 * Recupera il contesto dei filtri per l'elaborazione del QR code.
 *
 * @param  {selector} ctx :
 *
 * @return {selector}
 *
 * @since 2.0.0
 */
function getQRcodeFiltersCtx(ctx) {
	return jQuery('.qrcode-filters', ctx);
}



/**
 * Recupera il contesto del fine-tuning per l'elaborazione del QR code.
 *
 * @param  {selector} ctx :
 *
 * @return {selector}
 *
 * @since 2.0.0
 */
function getQRcodeFineTuningCtx(ctx) {
	return jQuery('.qrcode-fine-tuning', ctx);
}
